@if (state.isOpen) {
  <div class="notice-backdrop" role="presentation" (click)="close()">
    <section
      class="notice-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="developmentNoticeTitle"
      (click)="$event.stopPropagation()"
    >
      <button
        type="button"
        class="close-button"
        aria-label="Close development notice"
        (click)="close()"
      >
        ×
      </button>

      <div class="notice-badge">Development Preview</div>

      <h2 id="developmentNoticeTitle">Arcane Legion is still under development.</h2>

      <p>
        Arcane Legion is currently being built as a fantasy RPG, card PvP, mission,
        progression, and faction-based strategy experience.
      </p>

      <p>
        Enter your email to join the beta list, receive updates, or do both.
      </p>

      <label for="leadEmail">Email address</label>

      <input
        id="leadEmail"
        name="leadEmail"
        type="email"
        [(ngModel)]="email"
        placeholder="you@example.com"
        autocomplete="email"
      />

      @if (feedbackMessage) {
        <div class="feedback" [class.success]="isSuccess">
          {{ feedbackMessage }}
        </div>
      }

      <div class="notice-actions">
        <button type="button" class="primary-action" (click)="submit('beta')">
          Begin Your Legion
        </button>

        <button type="button" class="secondary-action" (click)="submit('updates')">
          Subscribe
        </button>

        <button type="button" class="both-action" (click)="submit('both')">
          Do Both
        </button>
      </div>

      <button type="button" class="maybe-later" (click)="close()">
        Maybe later
      </button>
    </section>
  </div>
}
